import {
  createMuiTheme,
  responsiveFontSizes,
  darken,
  lighten,
} from '@material-ui/core/styles';
import grey from '@material-ui/core/colors/grey';

const theme = createMuiTheme({
  font: {
    regular: 'Roboto',
    medium: 'Roboto-Medium',
    bold: 'Roboto-Bold',
    light: 'Roboto-Light',
    semiBold: 'Lato-Bold',
    secondary: 'Lato',
  },
  name: 'Blue Panther',
  palette: {
    background: {
      sidebarActiveItem: '#F5F6FA',
      defaultLightGrey: '#F5F6FA',
      primary: {
        light: lighten('#002fa7', 0.2),
        main: '#002fa7',
        dark: darken('#002fa7', 0.4),
      },
      warning: {
        light: '#ffe0b2',
        main: darken('#ffe0b2', 0.2),
        dark: darken('#ffe0b2', 0.4),
      },
      error: {
        light: '#ff8a8066',
        main: darken('#ff8a8066', 0.2),
        dark: darken('#ff8a8066', 0.4),
      },
    },
    primary: {
      // light: '#65bffb',
      main: '#002fa7',
      // dark: '#4476fd',
    },
    secondary: {
      light: '#65bffb',
      main: '#00a8ff',
      dark: '#4476fd',
    },
    link: {
      enabled: '#2779f6',
    },
    type: 'light',
  },
  typography: {
    fontFamily: 'Roboto',
    button: {
      textTransform: 'none',
    },
  },
  spacing: 4,
  overrides: {
    MuiTabs: {
      root: {
        borderBottom: 'none',
      },
      indicator: {
        backgroundColor: 'transparent',
      },
    },
    MuiTab: {
      root: {
        opacity: '1 !important',
        color: 'black',
        textTransform: 'none',
        backgroundColor: grey[300],
        '&:hover': {
          backgroundColor: grey[400],
        },
        '&:focus': {
          color: 'black',
        },
        '&$selected': {
          backgroundColor: '#ffffff',
          boxShadow: '1px 1px 4px rgba(150,150,150,0.1)',
        },
      },
    },
  },
});

export default responsiveFontSizes(theme);
